import { useRouter } from 'next/router';

import React, { ElementType, PropsWithChildren } from 'react';

import { MenuItemWithSymbols } from '@thinkific/chalk/recipes/MenuItemWithSymbols';

import MenuIcon from 'components/new/ui/MenuIcon/MenuIcon';
import NavList from 'components/new/ui/MenuList/MenuList';

import * as css from './Sidebar.css';

export interface SidebarNavItem {
  isVisible?: boolean;
  dataQa?: string;
  dataUserPilotId?: string;
  path?: string;
  label: string;
  icon: ElementType;
  onClick?: () => void;
}

export const BaseSidebar = ({
  navItems,
  children,
}: { navItems: SidebarNavItem[] } & PropsWithChildren) => {
  const router = useRouter();
  return (
    <nav className={css.sidebar}>
      <div className={css.container} data-qa="sidebar">
        {navItems.length > 0 && (
          <NavList>
            {navItems.map(
              (item) =>
                item.isVisible && (
                  <MenuItemWithSymbols
                    active={router.pathname === item.path}
                    data-qa={item.dataQa}
                    data-user-pilot-id={item.dataUserPilotId}
                    key={item.path}
                    label={item.label}
                    leadSymbol={
                      item.icon && <MenuIcon className={css.staticNavItem} iconName={item.icon} />
                    }
                    onClick={item.onClick}
                  >
                    {item.label}
                  </MenuItemWithSymbols>
                )
            )}
          </NavList>
        )}
        {children}
      </div>
    </nav>
  );
};

export default BaseSidebar;
